import * as React from "react";
import { Button, styled } from "@mui/material";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";

//region [[ Styles ]]
export const RoundActionButtonView = styled(Button)(({ theme }) => ({
  borderRadius: "8px",
  textTransform: "capitalize",
  color: RosebudColorMap.green2,
  paddingTop: "2px",
  paddingBottom: "2px",
  paddingLeft: "10px",
  paddingRight: "10px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RoundedActionButtonProps {
  className?: string;
  onClick?: (e) => void;
  displayText?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RoundedActionButton = ({ ...props }: RoundedActionButtonProps) => (
  <RoundActionButtonView
    className={props.className}
    variant={"outlined"}
    color={"primary"}
    onClick={props.onClick}
  >
    {props.displayText || "Add"}
  </RoundActionButtonView>
);
